// THIS FILE IS AUTO GENERATED
import { GenIcon } from '../lib/index.mjs';
export function CgAlignMiddle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none"},"child":[{"tag":"path","attr":{"d":"M13 9H17V15H13V9Z","fill":"currentColor","fillOpacity":"0.5"},"child":[]},{"tag":"path","attr":{"d":"M7 6H11V18H7V6Z","fill":"currentColor"},"child":[]}]})(props);
};
